<template>
<!-- 在线展览详情 -->
    <div class="exhibition_detail_warp">
        <BaseDetail>
            <div slot="cont" class="cont_warp">
                <img class="cont_top_img" src="https://www.ynggwhy.cn/file/hbY3dGDs5jDBxn6RTX/2020-10-11/source/6d2060f841284afd9d748cf067879f27.jpeg" alt="">
                <div class="top_info">
                    <div class="cont_top_title">云南民间故事展演</div>
                    <div class="behavior_box">
                        <div>浏览 30 </div>
                        <div class="behavior_list">
                            <div class="behavior_item">
                                <svg-icon icon-class="thumb" class-name="item_icon" /> 0
                            </div>
                            <div class="behavior_item">
                                <i class="el-icon-star-off item_icon"  /> 0
                            </div>
                            <div class="behavior_item">
                                <i class="el-icon-share item_icon"/> 分享
                            </div>
                        </div>
                        <el-button type="primary">我要看展</el-button>
                    </div>
                </div>
            </div>
        </BaseDetail>
    </div>
</template>

<script>
import BaseDetail from '@c/BaseDetail'

export default {
    name: 'activityDetail',
    components: {
        BaseDetail
    },
    data() {
        return {

        }
    },
    methods: {

    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">
.exhibition_detail_warp {
    background: #f8f8f8;
    min-height: calc(100vh - 315px);
    .cont_warp {
        .cont_top_img {
            width: 100%;
            height: 392px;
            border-radius: 5px 5px 0 0;
        }
        .top_info {
            padding: 19px 30px 35px 30px;
            color: #656567;
            line-height: 1;
            font-size: 20px;
        }
        .cont_top_title {
            font-size: 24px;
            font-weight: 800;
            color: #000;
        }
        .behavior_box {
            display: flex;
            align-items: center;
            font-size: 20px;
            color: #777;
            padding: 27px 0 20px;
        }
        .behavior_list {
            margin-right: auto;
            margin-left: 20px;
            display: flex;
            .behavior_item {
                width: 118px;
                height: 47px;
                line-height: 47px;
                text-align: center;
                border-radius: 5px;
                background: #f5f5f5;
                cursor: pointer;
                margin-left: 18px;
            }
        }
        .item_icon {
            font-size: 23px;
        }
    }
}
</style>